import React, { useEffect } from 'react';
import { Gradient } from '@/components/Gradient/Gradient';

// a hook to create a gradient
/*
export const useGradient = (canvasId = 'gradient-canvas', className = '') => {

    useEffect(() => {
        const gradient: any = new Gradient();
        gradient.initGradient(`#${canvasId ?? 'gradient-canvas'}`);
    }, [canvasId]);

    return (
        <canvas
            id={canvasId ?? 'gradient-canvas'}
            style={{ transform: 'skewY(-14deg)' }}
            className={`ghost-inspector-hide z-0 absolute top-[-140px] left-0 w-full h-[40%] sm:h-1/2 lg:h-2/3 ${className}`}
        />
    );

    // return (
    //     <canvas
    //         id='gradient-canvas'
    //         style={{ transform: 'skewY(-14deg)' }}
    //         className={`
    //                 absolute
    //                 z-0
    //
    //                 left-0
    //                 top-0
    //
    //                 w-[100vw]
    //
    //                 h-[50vh]
    //                 top-[-30vh]
    //
    //                 sm:h-[50vh]
    //                 sm:top-[-20vh]
    //
    //                 md:h-[60vh]
    //                 md:top-[-20vh]-not
    //
    //                 lg:h-[30vh]
    //                 lg:top-[-10vh]
    //
    //            `}
    //     />
    // );
};
*/

// a gradient background
export const GradientBackground = ({ id = 'gradient-canvas', className = '', style = {} }) => {

    useEffect(() => {
        const gradient: any = new Gradient();
        gradient.initGradient(`#${id ?? 'gradient-canvas'}`);
    }, [id]);

    return (
        <canvas
            id={id ?? 'gradient-canvas'}
            className={`ghost-inspector-hide z-0 absolute top-[-140px] left-0 w-full h-[40%] sm:h-1/2 lg:h-2/3 ${className}`}
            style={{ transform: 'skewY(-14deg)', ...style }}
        />
    );
};

export default GradientBackground;
